import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const coOwnerViewInitValue = {
  data: {
    selectedPartner: null,
    name: '',
    cif: '',
    email: '',
    percent: 0,
    comments: '',
    partnerOptions: [],
    isValidPercent: false,
    isValidEmail: false,
  },
  actions: {
    handleChangeSelectedPartner(): void {},
    handleChangeName(): void {},
    handleChangeCif(): void {},
    handleChangeEmail(): void {},
    handleChangePercent(): void {},
    handleChangeComments(): void {},
    handleFetchPartnersByTerm(): Promise<
      CustomAsyncSelectOption[] | undefined
    > {
      return Promise.resolve([]);
    },
    handleSaveCoOwner(): void {},
  },
};
